// Realtime client entry — importing this module registers both custom elements
// (ADR-0013). `application.js` imports it for the side effect, the same way it
// previously imported the two `.js` files it replaces.

export { type DataFrame, type RealtimeFrame, type TurboStreamFrame, parseFrame } from "./frame";
export {
  type FrameHandler,
  type Subscription,
  REALTIME_TUNING,
  hubStreamUrl,
  resetForTests,
  socketUrl,
  subscribe,
} from "./socket";
export { MercureDataSource, TurboMercureStreamSource, defineRealtimeElements } from "./elements";

import { defineRealtimeElements } from "./elements";

defineRealtimeElements();
